import _ from 'lodash';
import { EmmaPartnerService } from '../types/EmmaPartnerService';
import { EmmaInsuranceService } from '../types/EmmaInsuranceService';
import { _get } from '../../../utils';

/* Insurance Services */
export const getHomepageShowAllService = (state: {}): boolean =>
  _.get(state, `hk-emma-web-core/ui.homepage.showAllInsuranceService`);
export const getPoInsuranceServiecs = (state: {}): EmmaInsuranceService =>
  _.get(state, `hk-emma-web-core/app.moduleConfig.emma-insurance.features`);
export const getCwpInsuranceServiecs = (state: {}): EmmaInsuranceService =>
  _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-partners.sections[0].features`,
  );
export const getProfileFeatures = (state: {}): Array<string> =>
  _get(state, `hk-emma-web-core/user.customer.features`);

/* Partner Services */
export const getPartnerSeeAllBtnUrl = (state: {}): Array<EmmaPartnerService> =>
  _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-partners.sections[0].seeAllButton.deepLink.query.url`,
  );
export const getPoPartnerServiecs = (state: {}): Array<EmmaPartnerService> =>
  _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-partners.sections[0].features`,
  );
export const getNumOfPoPartnerServiecs =
  (state: {}): Array<EmmaPartnerService> =>
    _.get(
      state,
      `hk-emma-web-core/app.moduleConfig.emma-partners.sections[0].numberOfIcons`,
    );

export const getCwpPartnerServiecs = (state: {}): Array<EmmaPartnerService> =>
  _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-partners.sections[1].features`,
  );
export const getNumOfCwpPartnerServiecs =
  (state: {}): Array<EmmaPartnerService> =>
    _.get(
      state,
      `hk-emma-web-core/app.moduleConfig.emma-partners.sections[1].numberOfIcons`,
    );

/* Locked Modal */
export const getLockedModalDialog = (state: {}): Object =>
  _.get(state, `hk-emma-web-core/ui.dialog`);

export const isCWP = (state: {}): boolean =>
  _.get(state, `hk-emma-web-core/app.moduleConfig.emma-insurance`)
    ? false
    : true;

/* News */
export const getAxaNews = (state: {}): any =>
  _.get(state, `hk-emma-web-core/home.news.health`);

/* Market Place News */
export const getMarketPlaceNews = (state: {}): any =>
  _.get(state, `hk-emma-web-core/home.news.marketplace`);

export const getMyPrivilegesFeatures = (state: {}): any => {
  return _.get(
    state,
    `hk-emma-web-module-my-privileges/myPrivileges.privilegeFeatures`,
  );
};

export const getMyPrivilegesFeaturesError = (state: {}): any =>
  _.get(
    state,
    `hk-emma-web-module-my-privileges/myPrivileges.privilegeFeaturesError`,
  );

/* News */
export const getBlogArticles = (state: {}): any =>
  _.get(state, `hk-emma-web-core/home.news.blogArticles`);
